import { render, staticRenderFns } from "./Hrprofile.vue?vue&type=template&id=25a278e0&"
import script from "./Hrprofile.vue?vue&type=script&lang=js&"
export * from "./Hrprofile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports